export enum EXPORT_TYPE {
  DOCX = "docx",
  PLAIN_TEXT = "plainText",
  PDF = "pdf",
  EMAIL = "email",
}

export enum DOCLIST_EXPORT_TYPE {
  FULL = "docListFull",
  TOC_PDF = "docListTocPdf",
}

export const EXPORT_LIST = [
  {
    type: EXPORT_TYPE.DOCX,
    label: "export.docx",
  },
  {
    type: EXPORT_TYPE.PLAIN_TEXT,
    label: "export.plainText",
  },
  {
    type: EXPORT_TYPE.PDF,
    label: "export.pdf",
  },
  {
    type: EXPORT_TYPE.EMAIL,
    label: "export.email",
  },
];

export const DOCLIST_EXPORT_LIST = [
  {
    type: DOCLIST_EXPORT_TYPE.FULL,
    label: "export.docList.full",
  },
  {
    type: DOCLIST_EXPORT_TYPE.TOC_PDF,
    label: "export.docList.tocPdf",
  },
];
